import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './Prose.module.css'
import { match } from '@/utils/pattern-match-util'

export interface ProseProps {
  children?: ReactNode

  /**
   * Variant to use.
   * - 'default' - default colors
   * - 'invert' - inverts the colors, for use on dark backgrounds
   */
  variant?: 'default' | 'invert'
}

/**
 * Component that renders prose text with proper styling.
 */
export function Prose({ children, variant = 'default' }: ProseProps) {
  return (
    <div
      className={cx(
        styles.root,
        match(variant, {
          invert: styles.invert,
          [match.DEFAULT]: null,
        }),
      )}
    >
      {children}
    </div>
  )
}
